var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"undermain"},[_vm._m(0),_c('callback-form',{staticClass:"undermain__form"},[_vm._v("Получить предложение")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"undermain__title"},[_vm._v("\n    Забронируйте авто по телефону и получите\n    дополнительную выгоду "),_c('span',[_vm._v("30 000 руб.")]),_c('sup',[_vm._v("*")])])
}]

export { render, staticRenderFns }